export const FETCH_GUIDELINE_INDEX_STARTED = 'FETCH_GUIDELINE_INDEX_STARTED';
export const FETCH_GUIDELINE_INDEX_SUCCEEDED =
  'FETCH_GUIDELINE_INDEX_SUCCEEDED';
export const FETCH_GUIDELINE_INDEX_FAILED = 'FETCH_GUIDELINE_INDEX_FAILED';
